export default "__VITE_ASSET__CSoGd2Fu__"